"use client";

import { formatSeconds } from "./format-seconds";
import { toIsoDuration } from "./to-iso-duration";
import { useCountdown } from "./use-countdown";

const TWENTY_FOUR_HOURS_IN_SECONDS = 86_400;

type Props = {
  initialSeconds: number;
};

export function LimitedTimeDealBadge({ initialSeconds }: Props) {
  const showCountdown = initialSeconds <= TWENTY_FOUR_HOURS_IN_SECONDS;
  const seconds = useCountdown(initialSeconds, { enabled: showCountdown });

  return (
    <span className="inline-flex items-center gap-1.5 bg-badge-timedeal-bg text-badge-timedeal-text px-2 rounded-sm">
      <span>Limited time deal</span>
      {showCountdown && (
        <time
          dateTime={toIsoDuration(seconds)}
          className="font-semibold leading-6"
          suppressHydrationWarning
        >
          {formatSeconds(seconds)}
        </time>
      )}
    </span>
  );
}
